import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import whatsapp from "../../assets/img/whatsapp.png";
import cointhumb from "../../assets/img/cointhumb.png";
import ssl from "../../assets/img/ssl.png";
import plus from "../../assets/img/18-plus.png";
import glogo from "../../assets/img/g-logo.png";
import gtlogo from "../../assets/img/gt-logo.png";
import { v4 as uuidv4 } from "uuid";
import logo from "../../assets/logo.webp";
import wchat from "../../assets/img/w-chat.webp";
import dchat from "../../assets/img/d-chat.webp";
import wchat1 from "../../assets/img1/w-chat.png";
import dchat1 from "../../assets/img1/d-chat.png";
import wallet from "../../assets/img/walet.png";
import logouticon from "../../assets/img/logoutt.png";
import girl from "../../assets/img/girl.webp";
import profile from "../../assets/img/profile.png";
import Swal from "sweetalert2";
import { BsChatRightDotsFill } from "react-icons/bs";

const Privacy = () => {


    let guestId = localStorage.getItem("guestId");
    const [data, setData] = useState(null); // State to store fetched data
    const [DatamarkUnseensettings, setDatamarkUnseensettings] = useState(null); // State to store fetched data

    const navigate = useNavigate();
    if (!guestId) {
        guestId = uuidv4(); // Generate a new UUID
    }
    const isAdmin = localStorage.getItem("isAdmin");
    useEffect(() => {
        if (!isAdmin === "false") {
            navigate("/");
            localStorage.clear();
        }
    }, [!isAdmin]);

    const logout = (e) => {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Log Out",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.clear();
                navigate("/"); // Redirect to home after logout
            }
        });
    };

    return (
        <>
            <div className="homepagesectiondesign">
                <div className="homepagedesign">
                    <div className="container d-none d-md-block">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="withdarawchat">
                                {/* <Link to="/Withdrawalchat" className="blinking-button"> */}
                                <Link to="/Withdrawalchat" className="blinking-button">
                                    <img src={wchat} alt="chat" width={"35px"} />
                                    <span>Withdraw Chat</span>
                                </Link>
                                <Link to="/DepositchatSocket" className="blinking-button">
                                    <img src={dchat} alt="chat" width={"35px"} />
                                    <span> Deposit Chat</span>
                                </Link>
                            </div>
                            {/* <div className="logodesign gamelogo">
                                <img src={logo} alt="Brand logo" />
                            </div> */}
                            <div className="depositchat">
                                <Link to="/wallet" className="blinking-button">
                                    <img src={wallet} alt="chat" width={"35px"} />
                                    <span>Wallet</span>
                                </Link>

                                <Link
                                    className="blinking-button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        logout(e);
                                    }}
                                >
                                    <i class="bi bi-box-arrow-right mx-1"></i>
                                    <span>Logout</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="Mobile_header d-md-none">
                        <div className="float_btn">
                            <div className="withdarawchat position-static">
                                {/* <Link to="/Withdrawalchat" className="blinking-button w-chat">
                                    <img src={wchat1} alt="chat" width={"135px"} />
                                </Link> */}
                                <Link to="/DepositchatSocket" className="blinking-button d-chat">
                                    <img src={dchat1} alt="chat" width={"135px"} />
                                    {/* <span> Deposit Chat</span> */}
                                </Link>
                            </div>
                        </div>

                        <div className="mob-header">
                            <div className="depositchat">
                                <Link to="/wallet" className="blinking-button">
                                    <img src={wallet} alt="chat" width={"35px"} />
                                    <span>Wallet</span>
                                </Link>
                            </div>
                            <div className="logodesign gamelogo">
                                <img src={logo} alt="Brand logo" />
                            </div>
                            <div className="depositchat">
                                <Link
                                    className="blinking-button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        logout(e);
                                    }}
                                >
                                    <img src={logouticon} alt="logout" />
                                    {/* <i class="bi bi-box-arrow-right mx-1"></i> */}
                                    <span>Logout</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="privacy_policy">
                    <div className="container">
                        <h2>Privacy Policy</h2>
                        <p>
                            Welcome to Gaming Online Book Gambling. Your
                            privacy is of utmost importance to us. This Privacy Policy outlines how we
                            collect, use, and safeguard your information.
                        </p>
                        <h3>**Information We Collect**</h3>
                        <p>
                            - Personal Information: Name, email, address, and contact details provided
                            during registration. - Usage Data: Information about your device, browsing
                            activities, and interactions on our website.
                        </p>
                        <h3>**How We Use Your Information**</h3>
                        <p>
                            - To provide and improve our services. - For account verification and
                            security purposes. - To send updates, promotions, and notifications.
                        </p>
                        <h3>**Data Security**</h3>
                        <p>
                            We implement advanced security measures to protect your data from
                            unauthorized access. However, no method of transmission is 100% secure.
                        </p>
                        <h3>**Cookies**</h3>
                        <p>
                            Our website uses cookies to enhance your experience. You can manage your
                            cookie preferences in your browser settings.
                        </p>
                        <h3>**Third-Party Sharing**</h3>
                        <p>
                            We do not share your personal information with third parties unless
                            required by law or with your consent.
                        </p>
                        <h3>**Your Rights**</h3>
                        <p>
                            You have the right to access, modify, or delete your personal information.
                            For requests, contact us at support@Gaming.online.
                        </p>
                        <p>
                            By using our website, you consent to the practices outlined in this
                            policy. Updates will be communicated on this page.
                        </p>
                        <h3>**Contact Us**</h3>
                        <p>
                            If you have questions regarding our Privacy Policy, please contact us:
                            <br />- India:<a href="tel:+91-1111111111"> +91 1111111111</a>
                        </p>
                    </div>
                </section>


                <footer className="footer">
                    <div className="container">
                        <div className="Disclaimer">
                            <ul>
                                <li>
                                    <Link to={"/Privacy"}>Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to={"/Disclaimer"}>Disclaimer </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="ssl_head">
                            <img src={ssl} alt="" />
                            <div className="ssl_heading">
                                <span>100% SAFE</span>
                                <p>Protected connection and encrypted data.</p>
                            </div>
                        </div>
                        <div className="License">
                            <p>
                                The website is operated and registered in Curaçao under License
                                No. 7048/JAZ. The registered address is E-Commerce Park
                                Heelsumstraat 51, Willemstad, Curacao. All transactions are
                                processed by the entity that owns and operates the website
                            </p>
                            <div>
                                <div className="License_logos">
                                    <span>
                                        <img src={plus} alt="" />
                                    </span>
                                    <span>
                                        <img src={glogo} alt="" />
                                    </span>
                                    <span>
                                        <img src={gtlogo} alt="" />
                                    </span>
                                </div>
                                <div className="stop-logo">
                                    <span>
                                        <img src="images/ball-logo.png" alt="" />
                                    </span>
                                    <span>
                                        <img src="images/gam-stop-logo.png" alt="" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="copyright">
                            <span>Copyright © 2026 All right reserved.</span>
                        </div>
                    </div>
                </footer>
            </div> 
        </>
    );
};

export default Privacy;
